"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_uid_1 = require("react-uid");
var warning_1 = __importDefault(require("warning"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var color_1 = require("@seaweb/coral/utils/color");
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var normalizeSize_1 = __importDefault(require("@seaweb/coral/utils/normalizeSize"));
var FieldContext_1 = __importDefault(require("./FieldContext"));
var LabelPositions;
(function (LabelPositions) {
    LabelPositions["Left"] = "left";
    LabelPositions["Top"] = "top";
})(LabelPositions = exports.LabelPositions || (exports.LabelPositions = {}));
var FieldContainer = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n\n  ", "\n"], ["\n  display: flex;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, labelPosition = _a.labelPosition;
    return styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: ", ";\n    margin: ", "px 0;\n    width: 100%;\n\n    ", "\n  "], ["\n    font-family: ", ";\n    margin: ", "px 0;\n    width: 100%;\n\n    ",
        "\n  "])), theme.typography.main, 4 * theme.spacing.factor, (function () {
        switch (labelPosition) {
            case LabelPositions.Left: {
                return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            flex-direction: row;\n          "], ["\n            flex-direction: row;\n          "])));
            }
            case LabelPositions.Top: {
                return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            flex-direction: column;\n            align-items: flex-start;\n          "], ["\n            flex-direction: column;\n            align-items: flex-start;\n          "])));
            }
            default:
                return null;
        }
    })());
});
var Asterisk = styled_1.default.span.attrs({ children: '*', 'aria-hidden': true })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var _b = _a.theme, spacing = _b.spacing, colors = _b.colors;
    return styled_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: 0 ", "px;\n    color: ", ";\n  "], ["\n    margin: 0 ", "px;\n    color: ", ";\n  "])), spacing.factor / 2, colors.secondary);
});
var Label = styled_1.default.div.attrs({ 'data-coral-field-label': '' })(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  transition: all 0.2s ease;\n\n  ", "\n"], ["\n  transition: all 0.2s ease;\n\n  ",
    "\n"])), function (_a) {
    var _b = _a.theme, colors = _b.colors, typography = _b.typography, spacing = _b.spacing, position = _a.position, width = _a.width;
    return styled_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", "px;\n\n    ", "\n  "], ["\n    color: ", ";\n    font-size: ", "px;\n\n    ",
        "\n  "])), colors.alternate, typography.sizes.main, (function () {
        switch (position) {
            case LabelPositions.Left: {
                return styled_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            padding: ", "px 0;\n            padding-right: ", "px;\n            text-align: right;\n            flex-basis: ", ";\n            flex-grow: 0;\n            flex-shrink: 0;\n          "], ["\n            padding: ", "px 0;\n            padding-right: ", "px;\n            text-align: right;\n            flex-basis: ", ";\n            flex-grow: 0;\n            flex-shrink: 0;\n          "])), 2 * spacing.factor, 6 * spacing.factor, width);
            }
            case LabelPositions.Top: {
                return styled_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            padding-bottom: ", "px;\n          "], ["\n            padding-bottom: ", "px;\n          "])), 2 * spacing.factor);
            }
            default:
                return null;
        }
    })());
});
var Message = styled_1.default.div.attrs({ 'data-coral-field-message': '' })(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var _b = _a.theme, typography = _b.typography, spacing = _b.spacing, colors = _b.colors, invalid = _a.invalid;
    return styled_1.css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: ", "px;\n    padding-top: ", "px;\n    color: ", ";\n  "], ["\n    font-size: ", "px;\n    padding-top: ", "px;\n    color: ", ";\n  "])), typography.sizes.small, spacing.factor, invalid ? colors.secondary : color_1.alp(colors.alternate, 0.5));
});
var InputContainer = styled_1.default.div.attrs({
    'data-coral-field-input-container': '',
})(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var InputWrapper = styled_1.default.div.attrs({ 'data-coral-field-input': '' })(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Field = react_1.forwardRef(function Field(_a, ref) {
    var children = _a.children, as = _a.as, _b = _a.role, role = _b === void 0 ? react_1.Children.count(children) > 1 ? 'group' : undefined : _b, idProp = _a.id, label = _a.label, _c = _a.labelPosition, labelPosition = _c === void 0 ? LabelPositions.Top : _c, _d = _a.labelWidth, labelWidthProp = _d === void 0 ? labelPosition === LabelPositions.Left ? '30%' : undefined : _d, _e = _a.invalid, invalid = _e === void 0 ? false : _e, message = _a.message, _f = _a.required, required = _f === void 0 ? false : _f, containerProps = _a.containerProps, wrapperProps = _a.wrapperProps, labelProps = _a.labelProps, messageProps = _a.messageProps, props = __rest(_a, ["children", "as", "role", "id", "label", "labelPosition", "labelWidth", "invalid", "message", "required", "containerProps", "wrapperProps", "labelProps", "messageProps"]);
    warning_1.default(Object.values(LabelPositions).includes(labelPosition), "Field: Unknown labelPosition: '" + labelPosition + "'.");
    warning_1.default(labelPosition === LabelPositions.Left || !labelWidthProp, "Field: `labelWidth` is ignored when `labelPostion` is not `LabelPositions.Left`.");
    var id = fallback_1.default(idProp, react_uid_1.useUID());
    var labelId = "field:" + id + "-label";
    var messageId = "field:" + id + "-message";
    var ctx = {
        id: id,
        labelId: labelId,
        messageId: messageId,
        invalid: invalid,
        required: required,
        role: role,
        isGroup: role === 'group',
    };
    return (react_1.default.createElement(FieldContext_1.default.Provider, { value: ctx },
        react_1.default.createElement(FieldContainer, __assign({ as: as, ref: ref, labelPosition: labelPosition, role: role }, props),
            react_1.default.createElement(Label, __assign({ id: labelId, position: labelPosition, width: normalizeSize_1.default(labelWidthProp), invalid: invalid }, labelProps),
                required && labelPosition === LabelPositions.Left && react_1.default.createElement(Asterisk, null),
                label,
                required && labelPosition === LabelPositions.Top && react_1.default.createElement(Asterisk, null)),
            react_1.default.createElement(InputContainer, __assign({}, containerProps),
                react_1.default.createElement(InputWrapper, __assign({}, wrapperProps), children),
                react_1.default.createElement(Message, __assign({ invalid: invalid, id: messageId, "aria-live": "polite", hidden: !message }, messageProps), message)))));
});
exports.default = react_1.memo(Field);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
